import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=bffa9b10&scoped=true&"
import script from "./TransactionView.vue?vue&type=script&lang=ts&"
export * from "./TransactionView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=bffa9b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa9b10",
  null
  
)

export default component.exports